import React, {useState, useEffect, useMemo, useContext, useRef} from 'react';
import {Container, Row, Col} from 'reactstrap';
import {CountdownCircleTimer} from 'react-countdown-circle-timer';

// import QuizLiveAnswer from '../components/quiz-live-answer';

import {TimerImagePlaceholder, TimerHead} from '../svgs';
import QuizControls from './quiz-controls';
import {Field, Form, Formik} from 'formik';
import {AnswerCheckBox} from '../../helpers/formik';
import AnswerDefaultBox from '../../helpers/formik/answer-default';
import QuizLiveAnswer from '../quiz-live-answer';
import {EslidesEvent, Presentation} from '../../types/presentation';
import {gql, useMutation, useQuery, useSubscription} from '@apollo/client';
import {Question} from '../../types/quiz';
import {InLinePreLoader} from '../preloader';

import getEncodedImageUrl from '../../helpers/get-encoded-image';

import {
    INSERT_QUIZ_ACTION,
    presentation_by_pk,
    question_query,
    question_subscription,
    quiz_actions
} from '../../gql/quiz-gql'
import axios from "axios";
import {useHistory, useLocation} from "react-router-dom";
import {Socket} from "socket.io-client";
import {delay} from "lodash";
import SproutVideo from "../sprout-video";
import SproutQuestionVideo from "../sprout-question-video";

const QuizQuestions: React.FC<{ locale: string; setLocale: any; ppt: Presentation; event: EslidesEvent; client: Socket }> = ({
                                                                                                                                 locale,
                                                                                                                                 setLocale,
                                                                                                                                 ppt,
                                                                                                                                 event,
                                                                                                                                 client
                                                                                                                             }) => {

    const [startTimer, setStartTimer] = useState(true);
    const [result, setResultPage] = useState(false);
    const [disableNext, setDisableNext] = useState(false);
    const [disablePodium, setDisablePodium] = useState(false);
    const [isStartTimer, setIsStartTimer] = useState(false);
    const [showTimer, setShowTimer] = useState(true);
    const [questionIndex, setQuestionIndex] = useState(0);
    const [quizTime, setQuizTime] = useState(0);
    // @ts-ignore
    const [connectedUserCount, setConnectedUserCount] = useState(parseInt(localStorage.getItem('connected_users')));
    // @ts-ignore
    const [answeredUserCount, setAnsweredUserCount] = useState(parseInt(localStorage.getItem('answered_users')));
    const slug = document.location.pathname.split("/")[1] || "invalid";
    let token: any = localStorage.getItem(`token-${slug}`);
    const [videoRef, setVideoRef] = useState(null);
    const [videoPlayer, setVideoPlayer] = useState(null);
    const [played, setPlayed] = useState(false);

    const iframeRef = useRef(null);
    const location = useLocation();

    const history = useHistory();
    const [secondData, setSecondData] = useState<{
        questions: Array<Question>;

    }>();

    const [actionData, setActionData] = useState({
        action: undefined,
        answered_count: undefined,
        id: undefined,
        presentation_id: undefined,
        question_index: undefined
    });
    const [optionData, setOptionData] = useState({
        action: undefined
    });


// init config
    useEffect(() => {
        configSocket();
    }, []);

// cache current_questions,current_questions_index in localStorage
    useEffect(() => {
        localStorage.setItem('current_questions', secondData?.questions[questionIndex].question ?? "");
        localStorage.setItem('current_questions_index', (questionIndex + 1) + "/" + secondData?.questions?.length);

    }, [questionIndex]);




    // sync actions using sockets
    useEffect(() => {
        if (actionData) {
            let type = actionData.action;
            let index = actionData.question_index

            if (type === 'next_question') {
                localStorage.setItem('answered_users', '0');

                // @ts-ignore
                setQuestionIndex(index);
            }
            console.log("EVENT_CHANGE", actionData.action)
        }
    }, [actionData]);


    // handle answer count  select/deselect from attendee
    useEffect(() => {

        if (optionData) {
            console.log("optionData >>", optionData)
            let type = optionData.action;
            console.log("optionData >>type", type)
            if (type === 'answer_count_in') {
                localStorage.setItem('answered_users',`${answeredUserCount+1}`);
                setAnsweredUserCount(answeredUserCount + 1);

            } else if (type === 'answer_count_out') {
                if (answeredUserCount > 0) {
                    localStorage.setItem('answered_users',`${answeredUserCount-1}`);
                    setAnsweredUserCount(answeredUserCount - 1);
                }
            }
        }
    }, [optionData]);

    // socket connection handles
    function configSocket() {
        // socket quiz-action-updates callback
        client.on('quiz-action-updates', function (data: any) {
            setActionData(data);
            console.log('quiz-action-updates------ 1', data);
        });
        // socket quiz-option-count-change callback
        client.on('quiz-option-count-change', function (data: any) {
            setOptionData(data);
            console.log('quiz-action-updates------ 1', data);
        });

        // api call for get user action from database
        axios
            .post(
                `${process.env.REACT_APP_API_ENDPOINT}/api/quiz/get-user-action`,
                {
                    _id: ppt._id,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            ).then((res) => {

            setQuestionIndex(res.data.data.question_index);
            setResultPage(false);
        });
    }

    const formRef = React.useRef<any>();

    // update question status true : attended , false : not attended
    const updateQuestionStatus = (questionIndex: number) => {
        try {
            axios
                .post(
                    `${process.env.REACT_APP_API_ENDPOINT}/api/quiz/update-question-status`,
                    {
                        _id: secondData?.questions[questionIndex].id,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                ).then((res) => {
                console.log(res);
            });
        } catch (e) {
            console.log(e);
        }

    }

    // update changes in database and push socket message to clients
    function updateAction(jsonData: any) {
        console.log("updateAction >>> ", jsonData)
        console.log("updateAction >>> ", `${process.env.REACT_APP_SOCKET_URL}/quiz-moderator-action-change`)

        const headers = {
            'Content-Type': 'application/json',
        }
        // api call for post user action changes
        axios.post(`${process.env.REACT_APP_SOCKET_URL}/quiz-moderator-action-change`, jsonData, {
            headers: headers
        })
            .then((response) => {
                console.log("response", response)
            })
            .catch((error) => {
                console.log("error", error)
            })
    }

    // handle next question for the quiz
    const nextQuestionEvent = () => {
        var index = questionIndex + 1;
        setShowTimer(true);
        if (secondData && index < secondData.questions.length) {
            //updateQuestionStatus(questionIndex)
            setQuestionIndex(index);
            setAnsweredUserCount(0)
            setStartTimer(true)
            setDisablePodium(true);
            setIsStartTimer(true);
            localStorage.setItem('answered_users', '0');
            playVideoBtn();
            if (index === secondData.questions.length - 1) {
                setDisableNext(true)

            } else {
                setDisableNext(false)
            }
        }
    }

    // getting the presentation  data from back end
    const {data: firstData, loading: firstLoading, error: firstError} = useQuery(presentation_by_pk, {
        variables: {
            id: ppt && ppt._id
        },
        skip: !ppt
    },)

    // getting the presentation questions  details from back end
    const {data: secondQueryData, loading: secondLoading, error: secondError} = useSubscription<{
        questions: Array<Question>;
    }>(question_subscription, {
        variables: {
            presentation_id: ppt._id,
        },
        skip: !ppt,
    });



    // set quiz question data
    useEffect(() => {
        console.log("POINT API CALLED QUES AND RES===>", secondQueryData);
        setSecondData(secondQueryData)
    }, [secondQueryData])

    useEffect(() => {

        let getVolume = ""
        if(secondData){
            if(secondData.questions[questionIndex].video_token ==="video"){
                // @ts-ignore
                let video = new global.SV.Player({ videoId: secondData.questions[questionIndex].video_id });
                //video.play();
                if (videoPlayer == null) {
                    setVideoPlayer(video)
                    // video.play();
                }
            }

        }

    },[secondData])

    const playVideoBtn = () => {


        console.log("inside btn click")

        // @ts-ignore

        if(videoPlayer){
            // @ts-ignore
            videoPlayer.setVolume(1);
            // @ts-ignore
            //videoPlayer.play();
        }


    }

    useEffect(() => {


        console.log("videoPlayer",videoPlayer)
        // if(videoPlayer){
        //     // @ts-ignore
        //     console.log("videoPlayer getVolume",videoPlayer.getVolume())
        //
        //     // @ts-ignore
        //    // videoPlayer.play()
        //     // @ts-ignore
        //     videoPlayer.bind("ready", (e: any) => {
        //         // @ts-ignore
        //         videoPlayer.setVolume(1);
        //         console.log("playing ready.....")
        //
        //     });
        //     // @ts-ignore
        //     videoPlayer.bind("play", (e: any) => {
        //         // @ts-ignore
        //         if(videoPlayer.getVolume() == 0){
        //             // @ts-ignore
        //             videoPlayer.setVolume(1);
        //         }
        //         console.log("playing play.....")
        //
        //     });
        // }

    },[videoPlayer]);

    if(videoPlayer){

        // @ts-ignore
        console.log("videoPlayer getVolume1",videoPlayer.getVolume())
    }


    useEffect(() => {
        // check startTimer is not undefined
        if (startTimer) {
            setShowTimer(true);
        }

    }, [startTimer]);


    useEffect(() => {
        var data = location.state;
        // @ts-ignore
        if (data?.data === "back_press") {
            setShowTimer(false);
            history.replace({...location, state: undefined});
            setDisablePodium(false);
            setDisableNext(false);
            setIsStartTimer(false);
        } else {
            //setShowTimer(true);
        }
        console.log("UPDATED_STATE", data)
    }, [location.state]);


    // cache current_questions,current_questions_index in localstorage
    if (secondData && secondData.questions.length > 0) {
        localStorage.setItem('current_questions', secondData?.questions[questionIndex]?.question ?? "");
        localStorage.setItem('current_questions_index', (questionIndex + 1) + "/" + secondData?.questions?.length);
    }


    // quiz timer counting event
    const renderTime = ({remainingTime}: { remainingTime: any }) => {

        // check remainingTime is not zero
        if (remainingTime !== 0) {
            setDisablePodium(true);
        }
        // check remainingTime for update startTimer
        if (remainingTime !== quizTime) {
            setIsStartTimer(true);
        }

        setQuizTime(remainingTime);

        // setting timer value for finding the end of the loop
        if (remainingTime === 0) {

            if (questionIndex !== (secondData?.questions.length ?? 0) - 1) {
                setDisableNext(false);
                if (isStartTimer) {
                    updateQuestionStatus(questionIndex)
                    // update action call api
                    updateAction({
                        presentationId: ppt._id,
                        action: "timer_end",
                        question_index: questionIndex
                    })
                    setIsStartTimer(false);
                }
            } else {
                if (isStartTimer) {
                    updateQuestionStatus(questionIndex)
                    // update action call api
                    updateAction({
                        presentationId: ppt._id,
                        action: "timer_end",
                        question_index: questionIndex
                    })
                    setIsStartTimer(false);
                }
            }
        } else {
            setDisableNext(true);

        }
        // check remainingTime is one for find end of the timer
        if (remainingTime === 1) {
            setStartTimer(false)
        }

        return (
            <div className="timer">
                <div className="value">{remainingTime}s</div>

            </div>
        );
    };



    console.log("firstData", firstData);

    // calculate answer count for each option
    function getAnswerCount(id: string | undefined) {
        let point = 0;
        if (secondData) {
            for (let i = 0; i < secondData.questions[questionIndex].responses.length; i++) {
                for (let j = 0; j < secondData.questions[questionIndex].responses[i].options.length; j++) {
                    if (secondData.questions[questionIndex].responses[i].options[j].question_option_id === id) {
                        point = point + 1;
                    }
                }
            }
        }
        return point;
    }


    console.log("QQ1",secondData?.questions[questionIndex])

    function playVideo() {




    }

    return (
            <div className="quiz-live-screen-container">
                <div className="grid">
                    <div className="timer-with-question" style={{alignItems: 'unset'}}>
                        <div className="event-details">
                            <Row className="align-items-center">
                                <Col md={2}> {event?.logo ?
                                    <img
                                        height={90}
                                        src={getEncodedImageUrl(event.logo, 110, 110, "contain")}
                                        alt="logo"
                                    /> : <img height={45} src="/images/logo-default.png" alt=""/>
                                }  </Col>
                                <Col></Col>
                                <Col md={6}><h5>{ppt.name}</h5></Col>
                            </Row>
                        </div>
                        <div className="timer-image-container"  style={{textAlign:secondData?.questions[questionIndex].active_media ==="video" ? "unset":"center"}}>
                            <div className="image-placeholder">

                                {
                                    /*show question image and question */
                                    secondData && secondData.questions.length > 0 && (secondData.questions[questionIndex].image && (secondData.questions[questionIndex].image !== undefined && secondData.questions[questionIndex].image !== "") || secondData?.questions[questionIndex]?.active_media ==="video")?
                                        <div style={{width: secondData?.questions[questionIndex].active_media ==="video" ? 325: 220,height:220}}>
                                            {
                                                secondData?.questions[questionIndex].active_media ==="video" ?
                                                    <div className='question-image' style={{height:'241px',width:'420px'}}>
                                                    {/*quiz question video components */}

                                                        <div className={"video-modal-content-first"}>
                                                            <iframe
                                                                id={secondData.questions[questionIndex].video_id!}
                                                                style={{borderRadius:'13px'}}
                                                                title="Presentation Video"
                                                                className="sproutvideo-player"
                                                                src={`https://videos.sproutvideo.com/embed/${secondData.questions[questionIndex].video_id!}/${secondData?.questions[questionIndex].video_token}?playsinline=true&bigPlayButton=true&showcontrols=false
        &seekBar=false&fullscreenButton=false&volume=1&type=sd`}
                                                                width="100%"
                                                                ref={iframeRef}
                                                                height="100%"
                                                                allowFullScreen
                                                            ></iframe>

                                                            <span onClick={()=>{

                                                                playVideoBtn()
                                                            }}>Click me</span>
                                                        </div>

                                                </div> :<img className='question-image' src={getEncodedImageUrl(secondData.questions[questionIndex].image)} alt="Question"/>

                                            }
                                        </div> : <TimerImagePlaceholder/>
                                }
                                {firstData && (
                                    <>
                                        {showTimer ?
                                            <div className="countdown-container">
                                                <TimerHead/>
                                                <CountdownCircleTimer
                                                    isPlaying={startTimer}
                                                    duration={firstData?.presentation_by_pk.timer ?? 0}
                                                    size={101}
                                                    strokeWidth={10}
                                                    strokeLinecap="square"
                                                    trailColor="transparent"
                                                    colors={[
                                                        ['#d7d8d9', 0.33],
                                                        ['#d7d8d9', 0.33],
                                                        ['#d7d8d9', 0.33],
                                                        ['#d7d8d9', 0.33],
                                                    ]}
                                                    onComplete={() => {
                                                        setDisablePodium(false);
                                                        setStartTimer(false);
                                                        setShowTimer(false);
                                                        console.log("questionIndexx", questionIndex, ((secondData?.questions.length ?? 0) - 1))

                                                        console.log("startTimer onComplete", startTimer);
                                                        return [true, 1000];
                                                    }
                                                    }
                                                >
                                                    {renderTime}
                                                </CountdownCircleTimer>
                                            </div>

                                            :
                                            <div className="countdown-container">
                                                <TimerHead/>
                                                <CountdownCircleTimer
                                                    isPlaying={false}
                                                    duration={0}
                                                    size={101}
                                                    strokeWidth={0}
                                                    strokeLinecap="square"
                                                    trailColor="transparent"
                                                    colors={[
                                                        ['#d7d8d9', 0.33],
                                                        ['#d7d8d9', 0.33],
                                                        ['#d7d8d9', 0.33],
                                                        ['#d7d8d9', 0.33],
                                                    ]}
                                                    onComplete={() => [false, 1000]}
                                                >
                                                    {<div className="timer">
                                                        <div className="value">0s</div>
                                                    </div>}
                                                </CountdownCircleTimer>
                                            </div>}

                                    </>


                                )}
                            </div>
                            <h5 style={{paddingTop:'30px', textAlign:secondData?.questions[questionIndex].active_media ==="video"? "center":"unset"}}>question {questionIndex + 1}/{secondData?.questions.length}</h5>
                            <p onClick={playVideo} style={{textAlign:secondData?.questions[questionIndex].active_media ==="video"? "center":"unset"}}>{secondData?.questions[questionIndex]?.question ?? ""}</p>
                        </div>
                        <div>
                            <span>Powered by</span>
                            <img src="/images/e-slides-logo.png" alt="e-slides-logo"/>
                        </div>
                    </div>
                    <div className="answers-main">
                        {/* Loading UI components */}
                        {secondLoading || !secondData || secondData.questions.length === 0 ? (
                            <div className='container'>
                                <div className='row'>
                                    <Col>
                                        <div className="quiz-live-answers-container"
                                             style={{justifyContent: 'center', display: 'flex'}}>
                                            <InLinePreLoader/>
                                        </div>
                                    </Col>
                                    <div>
                                    </div>
                                </div>
                            </div>


                        ) : (
                            /* display question option components*/
                            !result ?
                                <div className='container'>
                                    <div className='row'>
                                        <Col>
                                            <div className="quiz-live-answers-container ">
                                                <Formik
                                                    innerRef={formRef}
                                                    onSubmit={values => console.log(values)}
                                                    initialValues={{}}
                                                >
                                                    {({values}) => {
                                                        // const padclass = answers.length > 4 ? answers.length > 6 ? 'padClassMax' : 'padClassActive' : '';
                                                        const padclass = ''
                                                        if (secondData.questions[questionIndex].options.length <= 4) {
                                                            return (
                                                                <Form>
                                                                    {
                                                                        secondData.questions[questionIndex].options.map((answer, i) => (
                                                                            <Field
                                                                                key={`answer#${answer.id}`}
                                                                                component={AnswerDefaultBox}
                                                                                alphabet={String.fromCharCode(i + 97)}
                                                                                name={`answer#${answer.id}`}
                                                                                id={`answer#${answer.id}`}
                                                                                padclass={`padClassActive`}
                                                                                label={answer.option}
                                                                            />
                                                                        ))
                                                                    }
                                                                </Form>
                                                            )
                                                        } else if (secondData.questions[questionIndex].options.length <= 6) {
                                                            var code = 96;
                                                            return (
                                                                <Form>
                                                                    <div className='container-fluid overflow-hidden'>
                                                                        <div className="row ">
                                                                            <div className="col ">
                                                                                {
                                                                                    secondData.questions[questionIndex].options.slice(0, 3).map((answer, i) => (

                                                                                        <Field
                                                                                            key={`answer#${answer.id}`}
                                                                                            component={AnswerDefaultBox}
                                                                                            alphabet={String.fromCharCode(++code)}
                                                                                            name={`answer#${answer.id}`}
                                                                                            id={`answer#${answer.id}`}
                                                                                            padclass={`padClassMax`}
                                                                                            label={answer.option}
                                                                                        />
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                            <div className="col ">
                                                                                {
                                                                                    secondData.questions[questionIndex].options.slice(3, 6).map((answer, i) => (

                                                                                        <Field
                                                                                            key={`answer#${answer.id}`}
                                                                                            component={AnswerDefaultBox}
                                                                                            alphabet={String.fromCharCode(++code)}
                                                                                            name={`answer#${answer.id}`}
                                                                                            id={`answer#${answer.id}`}
                                                                                            padclass={`padClassMax`}
                                                                                            label={answer.option}
                                                                                        />
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </Form>
                                                            )

                                                        } else if (secondData.questions[questionIndex].options.length <= 8) {
                                                            var code = 96;
                                                            return (
                                                                <Form>
                                                                    <div className='container-fluid overflow-hidden'>
                                                                        <div className="row ">
                                                                            <div className="col ">
                                                                                {
                                                                                    secondData.questions[questionIndex].options.slice(0, 4).map((answer, i) => (

                                                                                        <Field
                                                                                            key={`answer#${answer.id}`}
                                                                                            component={AnswerDefaultBox}
                                                                                            alphabet={String.fromCharCode(++code)}
                                                                                            name={`answer#${answer.id}`}
                                                                                            id={`answer#${answer.id}`}
                                                                                            padclass={'padClass20'}
                                                                                            label={answer.option}
                                                                                        />
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                            <div className="col ">
                                                                                {
                                                                                    secondData.questions[questionIndex].options.slice(4, 8).map((answer, i) => (

                                                                                        <Field
                                                                                            key={`answer#${answer.id}`}
                                                                                            component={AnswerDefaultBox}
                                                                                            alphabet={String.fromCharCode(++code)}
                                                                                            name={`answer#${answer.id}`}
                                                                                            id={`answer#${answer.id}`}
                                                                                            padclass={'padClass20'}
                                                                                            label={answer.option}
                                                                                        />
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </Form>
                                                            )
                                                        } else {
                                                            var code = 96;
                                                            return (
                                                                <Form>
                                                                    <div className='container-fluid overflow-hidden'>
                                                                        <div className="row ">
                                                                            <div className="col ">
                                                                                {
                                                                                    secondData.questions[questionIndex].options.slice(0, 5).map((answer, i) => (

                                                                                        <Field
                                                                                            key={`answer#${answer.id}`}
                                                                                            component={AnswerDefaultBox}
                                                                                            alphabet={String.fromCharCode(++code)}
                                                                                            name={`answer#${answer.id}`}
                                                                                            id={`answer#${answer.id}`}
                                                                                            padclass={padclass}
                                                                                            label={answer.option}
                                                                                        />
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                            <div className="col ">
                                                                                {
                                                                                    secondData.questions[questionIndex].options.slice(5, secondData.questions[questionIndex].options.length).map((answer, i) => (


                                                                                        <Field
                                                                                            key={`answer#${answer.id}`}
                                                                                            component={AnswerDefaultBox}
                                                                                            alphabet={String.fromCharCode(++code)}
                                                                                            name={`answer#${answer.id}`}
                                                                                            id={`answer#${answer.id}`}
                                                                                            padclass={padclass}
                                                                                            label={answer.option}
                                                                                        />
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </Form>
                                                            )


                                                        }
                                                    }}
                                                </Formik>
                                            </div>
                                        </Col>
                                    </div>
                                </div> : <></>
                        )
                        }
                        {/* Display result page components */}
                        {result && secondData && <Container fluid>
                            <Row>
                                <Col>
                                    <div className="quiz-live-answers-container m-t-60">
                                        <h5 style={{color: 'white'}}>Question {questionIndex + 1}/{secondData?.questions.length}</h5>
                                        <p className="q"
                                           style={{color: 'white'}}>{secondData?.questions[questionIndex].question}</p>
                                        {
                                            secondData.questions[questionIndex].options.map((answer, index) => (
                                                <QuizLiveAnswer
                                                    totalAnswersAggregate={123}
                                                    answerLength={secondData.questions[questionIndex].options.length}
                                                    key={answer.id}
                                                    alphabet={String.fromCharCode(index + 97)}
                                                    answer={answer.option}
                                                    totalAnswers={getAnswerCount(answer.id)}
                                                    value={answer.correct}
                                                />
                                            ))
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                        }
                    </div>
                </div>
                {/* Question Bottom control component */}
                <QuizControls questionIndex={questionIndex} answerId={secondData?.questions[questionIndex]?.id ?? ""}
                              usersLength={connectedUserCount} presentationId={ppt._id} nextQuestion={nextQuestionEvent}
                              answersLength={answeredUserCount} nextDisabled={disableNext}
                              podiumDisabled={disablePodium}
                              setResultPage={setResultPage} setStartTimer={setStartTimer}/>
            </div>
        )
    }

    export default QuizQuestions;
